import LockIcon from '@mui/icons-material/Lock';
import { Alert, Box, Button, Card, CardContent, TextField, Typography } from '@mui/material';
import { FormEvent, ReactNode, useState } from 'react';
import { Title } from 'react-admin';
import { devToolsPassword, isConfigured, isUnlocked, unlock } from './devToolsAuth';

interface DevToolsGateProps {
  children: ReactNode;
  /** Injectable for tests; defaults to the build-time env var. */
  password?: string;
}

export const DevToolsGate = ({ children, password = devToolsPassword() }: DevToolsGateProps) => {
  const [unlocked, setUnlocked] = useState(() => isUnlocked());
  const [attempt, setAttempt] = useState('');
  const [failed, setFailed] = useState(false);

  if (unlocked) return <>{children}</>;

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (unlock(attempt, password)) {
      setUnlocked(true);
    } else {
      setFailed(true);
    }
  };

  return (
    <Card sx={{ maxWidth: 420, mt: 4, mx: 'auto' }}>
      <Title title="Dev Tools" />
      <CardContent>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <LockIcon />
          <Typography variant="h6">Dev Tools</Typography>
        </Box>
        {!isConfigured(password) ? (
          <Alert severity="warning">Dev Tools password is not configured for this environment.</Alert>
        ) : (
          <form onSubmit={submit}>
            <TextField label="Password" type="password" fullWidth autoFocus value={attempt} onChange={(e) => setAttempt(e.target.value)} error={failed} helperText={failed ? 'Incorrect password' : ' '} />
            <Button type="submit" variant="contained" sx={{ mt: 1 }}>
              Unlock
            </Button>
          </form>
        )}
      </CardContent>
    </Card>
  );
};
